import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const useConstructExportMessages = () => {
  const { t } = useTranslation('genie');

  const handleConstructMessages = useCallback(
    (messages) => {
      return messages.map(({ message, count, interest, action, uncertainty }) => {
        const prefix = count ? `${count}: ` : '';
        const scores = `R1: ${interest}% | R2: ${action}% | ${t('certainty')}: ${uncertainty}%`;
        return prefix + message + '\n' + scores + '\n';
      });
    },
    [t],
  );

  return handleConstructMessages;
};

export default useConstructExportMessages;
